import { login } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  PERFORM_LOGIN,
  PERFORM_LOGIN_START,
  PERFORM_LOGIN_COMPLETE,
  PERFORM_LOGIN_ERROR,
  VERIFY_RESET_PASSWORD_EMAIL,
  VERIFY_RESET_PASSWORD_EMAIL_START,
  VERIFY_RESET_PASSWORD_EMAIL_COMPLETE,
  VERIFY_RESET_PASSWORD_EMAIL_ERROR,
  VERIFY_RESET_PASSWORD_OTP,
  VERIFY_RESET_PASSWORD_OTP_START,
  VERIFY_RESET_PASSWORD_OTP_COMPLETE,
  VERIFY_RESET_PASSWORD_OTP_ERROR,
  VERIFY_EMAIL_OTP,
  VERIFY_EMAIL_OTP_START,
  VERIFY_EMAIL_OTP_COMPLETE,
  VERIFY_EMAIL_OTP_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import { setAuthDetails } from '../../../utils/AuthDetailsUtil';
import { getUserProfile } from '../userProfile/saga';

export function* performLogin({
  payload: { params, onSuccessOfLogin, redirectToAccountSetup },
}) {
  try {
    yield put({
      type: PERFORM_LOGIN_START,
    });
    const { response, error } = yield call(login.performLogin, {
      params,
    });

    if (!!response) {
      yield put({
        type: PERFORM_LOGIN_COMPLETE,
        payload: {
          data: response.token,
        },
      });
      if (
        response.form_status !== undefined &&
        response.form_status !== null &&
        response.form_status === 'NOT_COMPLETED'
      ) {
        yield call(redirectToAccountSetup);
      } else {
        yield call(onSuccessOfLogin);
      }
    } else {
      yield put(
        onPerformLoginError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onPerformLoginError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* verifyEmailOtp({ payload: { params, onSuccessOfLogin } }) {
  try {
    yield put({
      type: VERIFY_EMAIL_OTP_START,
    });

    if (params) {
      var { response, error } = yield call(login.verifyEmailOtp, {
        params,
      });
    } else {
      const { refresh_token } = yield call(login.isAccessTokenValid);
      var { response, error } = yield call(login.fetchAuthToken, {
        refresh_token,
      });
    }

    if (!!response) {
      if (params) {
        var { refresh: refresh_token } = response;

        var { success, error } = yield call(login.fetchAuthToken, {
          refresh_token,
        });
        yield delay(3000);
        if (success) {
          yield call(getUserProfile);
          yield put({
            type: VERIFY_EMAIL_OTP_COMPLETE,
          });
          yield call(onSuccessOfLogin);
        } else {
          yield put(
            onVerifyEmailOtpError({
              error: error?.data.message ? error?.data.message : errorStrings.commonError,
            }),
          );
        }
      } else {
        yield put({
          type: VERIFY_EMAIL_OTP_COMPLETE,
        });
        yield call(onSuccessOfLogin);
      }
    } else {
      //call logout
      yield put(
        onVerifyEmailOtpError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onVerifyEmailOtpError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* verifyResetPasswordEmail({ payload: { params, onSuccess } }) {
  try {
    yield put({
      type: VERIFY_RESET_PASSWORD_EMAIL_START,
    });

    const { response, error } = yield call(login.verifyResetPasswordEmail, {
      params,
    });

    if (!!response) {
      yield put({
        type: VERIFY_RESET_PASSWORD_EMAIL_COMPLETE,
        payload: {
          data: response.token,
        },
      });
      onSuccess?.();
    } else {
      yield put(
        onVerifyResetPasswordEmailError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onVerifyResetPasswordEmailError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* verifyResetPasswordOtp({ payload: { params, onSuccess } }) {
  try {
    yield put({
      type: VERIFY_RESET_PASSWORD_OTP_START,
    });
    const { response, error } = yield call(login.verifyResetPasswordOtp, {
      params,
    });

    if (!!response) {
      yield put({
        type: VERIFY_RESET_PASSWORD_OTP_COMPLETE,
        payload: { data: response.token },
      });
      onSuccess();
    } else {
      yield put(
        onVerifyResetPasswordOtpError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onVerifyResetPasswordOtpError({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onVerifyResetPasswordOtpError = (payload = {}) => ({
  type: VERIFY_RESET_PASSWORD_OTP_ERROR,
  payload,
});

const onPerformLoginError = (payload = {}) => ({
  type: PERFORM_LOGIN_ERROR,
  payload,
});

const onVerifyResetPasswordEmailError = (payload = {}) => ({
  type: VERIFY_RESET_PASSWORD_EMAIL_ERROR,
  payload,
});

const onVerifyEmailOtpError = (payload = {}) => ({
  type: VERIFY_EMAIL_OTP_ERROR,
  payload,
});

function* watchVerifyEmail() {
  yield takeLatest(VERIFY_EMAIL_OTP, verifyEmailOtp);
}

function* watchVerifyResetPasswordOtpp() {
  yield takeLatest(VERIFY_RESET_PASSWORD_OTP, verifyResetPasswordOtp);
}

function* watchPerformLogin() {
  yield takeLatest(PERFORM_LOGIN, performLogin);
}

function* watchVerifyResetPasswordEmail() {
  yield takeLatest(VERIFY_RESET_PASSWORD_EMAIL, verifyResetPasswordEmail);
}

export const sagas = [
  watchVerifyResetPasswordOtpp,
  watchPerformLogin,
  watchVerifyResetPasswordEmail,
  watchVerifyEmail,
];
